import React from 'react';
import ProfileLayout from './ProfileLayout';
import { ConfigurationTokensPanel } from '../configuration/ConfigurationTokensPanel';

// The Configuration API token section of Settings.
//
// Its own route rather than a block on the Configuration page: a token is a credential the person
// running a script is sent to fetch ("open Settings → Configuration API token"), and that
// instruction needs a link to point at — same as the Figma and Customer.io tokens.
export default function ConfigurationTokenSettingsPage() {
  return (
    <ProfileLayout>
      <div>
        <h2 className="text-sm font-bold text-ink mb-1">Configuration API token</h2>
        <p className="text-xs text-ink-dim mb-4 font-medium">
          Scripts set and read a brand's configuration over the public API with this token, naming
          the brand on every call. It is yours alone: it acts with your permissions and stops
          working the moment you lose them. Never share it — a colleague mints their own here.
        </p>
        <ConfigurationTokensPanel />
      </div>
    </ProfileLayout>
  );
}
